import {
  type Step,
  StepsProgress,
} from "@arcadeai/design-system/components/ui/molecules/steps-progress";
import type { JSX } from "react";
import type { OnboardingSidebarStepDef } from "@/app/onboarding-first-win/components/onboarding-sidebar";
import type { OnboardingStep } from "@/app/onboarding-first-win/lib/onboarding-shared";

type OnboardingMobileTopBarProps = {
  currentStepId: OnboardingStep;
  steps: OnboardingSidebarStepDef[];
};

function toProgressStepStatus(
  step: OnboardingSidebarStepDef,
  currentStepId: OnboardingStep
): Step["status"] {
  if (step.id === currentStepId) {
    return step.status === "complete" ? "complete" : "active";
  }
  if (step.status === "future") {
    return "incomplete";
  }
  return step.status;
}

function toProgressStep(
  step: OnboardingSidebarStepDef,
  currentStepId: OnboardingStep
): Step {
  return {
    id: step.id,
    label: step.label,
    status: toProgressStepStatus(step, currentStepId),
    onClick: step.onClick,
  };
}

export function OnboardingMobileTopBar({
  currentStepId,
  steps,
}: OnboardingMobileTopBarProps): JSX.Element {
  return (
    <StepsProgress
      className="shrink-0 rounded-none border-x-0 border-t-0 md:hidden"
      steps={steps.map((step) => toProgressStep(step, currentStepId))}
    />
  );
}
